import TotalPlayers from './TotalPlayers.container';

export default TotalPlayers;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/sections/totalPlayers/index.js